
// Declare urls interface
export interface ApiUrls {
  Studies: string;
  ActiveEnrollments: string;
  FutureEnrollments: string;
  EnrollmentData: string;
  ActiveHomeAlerts: string;
  SelectedStudies: string;
  SelectedStudies_Document: string;
  SelectedStudies_Petition: string;
  RegistrationFees: string;
  AvailableInterviews: string;
  CandidateInterviews: string;
  SelectedInterview: string;
  InterviewProgress: string;
  GoogleEmail: string;
  InitialWizard: string;
  PersonalData: string;
  Countries: string;
  Cities: string;
  CitySuggestion: string;
  CitySuggestion_IsPermitted: string;
  CitySuggestion_Voivodeships: string;
  Agencies: string;
  IsEmailUnique: string;
  ForeignerQuestionnaireQuestions: string;
  CandidateDashboardData: string;
  CandidatePermissions: string;
  CandidatePermissions_UpdatePermissionToChangePhoto: string;
  CandidateData_HasDashboardAccess: string;
  CandidateData_CandidateType: string;
  Administration_DeleteCurrentUser: string;
  Administration_LogError: string;
}

// Define endpoint routes
const apiEndpoints: ApiUrls = {
  Studies: 'available-studies',
  ActiveEnrollments: 'home/active-enrollments',
  FutureEnrollments: 'home/future-enrollments',
  EnrollmentData: 'home/enrollment-data',
  ActiveHomeAlerts: 'home/active-alerts',
  SelectedStudies: 'selected-studies',
  SelectedStudies_Document: 'selected-studies/documents',
  SelectedStudies_Petition: 'documents/petition',
  RegistrationFees: 'selected-studies/registration-fees',
  InitialWizard: 'initial-wizard',
  PersonalData: 'dashboard/personal-data',
  AvailableInterviews: 'interviews/available-interviews',
  CandidateInterviews: 'interviews/candidate-interviews',
  SelectedInterview: 'interviews/selected-interview',
  InterviewProgress: 'interviews/progress',
  GoogleEmail: 'interviews/google-email',
  Countries: 'select-lists/countries',
  Cities: 'select-lists/cities',
  CitySuggestion: 'select-lists/cities',
  CitySuggestion_IsPermitted: 'select-lists/cities/is-city-suggestion-permitted',
  CitySuggestion_Voivodeships: 'select-lists/voivodeships',
  Agencies: 'select-lists/agencies',
  ForeignerQuestionnaireQuestions: 'select-lists/foreigner-questionnaire-questions',
  CandidateDashboardData: 'candidate-data/dashboard-data',
  CandidatePermissions: 'candidate-data/permissions',
  IsEmailUnique: 'initial-wizard/is-email-unique',
  CandidatePermissions_UpdatePermissionToChangePhoto: 'candidate-data/permissions/photo',
  CandidateData_HasDashboardAccess: 'candidate-data/has-dashboard-access',
  CandidateData_CandidateType: 'candidate-data/candidate-type',
  Administration_DeleteCurrentUser: 'administration/delete-current-user',
  Administration_LogError: 'administration/log-error'
};

// Append apiRoot to all endpoints
Object.keys(apiEndpoints).forEach(key =>
  apiEndpoints[key] = `/api/${apiEndpoints[key]}`
);

// Export
export const ApiUrls: ApiUrls = apiEndpoints;
